const TWITTER_TRACK_ID: string = "o97s6";
const UTM_SOURCE: string = "utm_source";
const UTM_MEDIUM: string = "utm_medium";
const UTM_CAMPAIGN: string = "utm_campaign";
const UTM_TERM: string = "utm_term";
const UTM_CONTENT: string = "utm_content";

function logEvent(event_name: string) {
  if ("gtag" in window) {
    (window as any).gtag("event", event_name, {
      event_category: event_name,
      event_label: event_name,
    });
  }
}

function logToTwitter(sale_amount: number, order_quantity: number) {
  if ("twttr" in window) {
    (window as any).twttr.conversion.trackPid(TWITTER_TRACK_ID, {
      tw_sale_amount: sale_amount,
      tw_order_quantity: order_quantity,
    });
  }
}

function logPageVisitToReddit() {
  if ("rdt" in window) {
    (window as any).rdt('track', 'ViewContent');
  }
}

function logPurchaseToReddit(sale_amount: number, order_quantity: number) {
  if ("rdt" in window) {
    (window as any).rdt('track', 'Purchase', {
      "itemCount": order_quantity,
      "value": sale_amount
    });
  }
}

function stringFormat(format: string, ...args: any[]): string {
  var args = Array.prototype.slice.call(arguments, 1);
  return format.replace(/{(\d+)}/g, function (match, number) {
    return typeof args[number] != "undefined" ? args[number] : match;
  });
}

/** A wrapper around a number that allows it to be passed around by reference. */
class NumberReference {
  value: number;

  constructor(initialValue: number) {
    this.value = initialValue;
  }
}

function getUtmCodes(): string {
  let output_string = "";
  output_string += "source=" + sessionStorage.getItem(UTM_SOURCE) ?? "";
  output_string += "medium=" + sessionStorage.getItem(UTM_MEDIUM) ?? "";
  output_string += "campaign=" + sessionStorage.getItem(UTM_CAMPAIGN) ?? "";
  output_string += "term=" + sessionStorage.getItem(UTM_TERM) ?? "";
  output_string += "content=" + sessionStorage.getItem(UTM_CONTENT) ?? "";
  return output_string;
}

function getUtmCampaign(): string {
  return sessionStorage.getItem(UTM_CAMPAIGN) ?? "";
}

function hasGclid(): string {
  const gclid = sessionStorage.getItem("gclid");
  if (gclid) {
    return "true";
  } else {
    return "false";
  }
}

export {
  logEvent,
  logToTwitter,
  stringFormat,
  NumberReference,
  getUtmCodes,
  getUtmCampaign,
  hasGclid,
  logPageVisitToReddit,
  logPurchaseToReddit
};
